import { getDataFromUrl } from '@utils'
import UserStore from './UserStore'
import Column from './Column'
import HomeState from './Home'
import Search from './Search'
import LiveStreamState from './LiveStream'
import AppStore from './AppStore'
import ExamStore from './ExamStore'
import PracticeTrain from './PracticeTrain'
import Topic from './Topic'
import trainingCourse from './TrainingCourse'
import IntlCommon from './IntlCommon'

export const initStore = () => {
  const data = getDataFromUrl()
  if (data) {
    UserStore.initStore(data.sessionInfo, data.userInfo)
    AppStore.initStore(data.homeId, data.theme, data.timeGap)
  }
}

export default {
  UserStore,
  Column,
  HomeState,
  Search,
  LiveStreamState,
  AppStore,
  ExamStore,
  PracticeTrain,
  Topic,
  trainingCourse,
  IntlCommon,
}
